import React from 'react';
import { cn } from '../../lib/utils';

export function Card({
  as: Component = 'div',
  interactive = false,
  children,
  className = '',
  ...props
}) {
  const interactiveStyles = interactive
    ? 'hover:bg-[var(--bg-hover)] hover:shadow-[var(--shadow-md)] transition-colors cursor-pointer'
    : '';

  return (
    <Component
      className={cn('bg-[var(--bg-elevated)] rounded-xl shadow-[var(--shadow-sm)] p-6', interactiveStyles, className)}
      {...props}
    >
      {children}
    </Component>
  );
}

export default Card;
